import { tabAccessControl } from "../../../_helpers/access-control";

let SalesOrderTabs = [
  {
    text: "All",
    path: `/sales-order`,
    applicationFeatureCode: "SalesOrder",
  },
  {
    text: "Planning",
    path: `/sales-planning`,
    applicationFeatureCode: "SalesOrderPlanning",
  },
  {
    text: "Label Printing",
    path: `/label-printing`,
    applicationFeatureCode: "LabelPrinting",
  },
  {
    text: "To Despatch",
    path: `/despatch-order`,
    applicationFeatureCode: "OrderPicking",
  },
  {
    text: "Despatched",
    path: `/despatched`,
    applicationFeatureCode: "OrderPicking",
  },
  {
    text: "To Manifest",
    path: `/manifest-order`,
    applicationFeatureCode: "ManifestOrder",
  },
  {
    text: "Pending Invoices",
    path: `/pending-invoice`,
    applicationFeatureCode: "Invoice",
  },
  {
    text: "Invoiced",
    path: `/invoiced-order`,
    applicationFeatureCode: "Invoice",
  },
  {
    text: "Enquiry",
    path: `/sales-order-profit-enquiry`,
    applicationFeatureCode: "SalesOrderEnquiry",
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(SalesOrderTabs).findIndex((x) => x.text == tabName);
}

export { SalesOrderTabs, GetIndexByTabName };
